import { render, staticRenderFns } from "./orderDetailpage.vue?vue&type=template&id=455ed72a&scoped=true"
import script from "./orderDetailpage.vue?vue&type=script&lang=js"
export * from "./orderDetailpage.vue?vue&type=script&lang=js"
import style0 from "./orderDetailpage.vue?vue&type=style&index=0&id=455ed72a&prod&lang=less"
import style1 from "./orderDetailpage.vue?vue&type=style&index=1&id=455ed72a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455ed72a",
  null
  
)

export default component.exports